export class Province {
    id : number;
    provinceCode : string;
    provinceName : string;
}